export class EmergencyAnnouncement {
  isCcMckay = true;
  companiesUniqId?: string[];
  subject?: string;
  message?: string;
  banner?: string;
  selectedGroups?: string[];
}
